<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="3">
          <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem label="创建人">
          <auto-complete :data="agentData" v-model="agentId" placeholder="全部" @on-select="handleAgent"></auto-complete>
        </ElFormItem>
        <ElFormItem label="平台">
          <ElSelect v-model="platform" style="width: 160px">
            <el-option :value="-1" label="不限"></el-option>
            <el-option :value="1" label="安卓"></el-option>
            <el-option :value="2" label="iOS"></el-option>
          </ElSelect>
        </ElFormItem>
        <drop-autoComplete label="游戏" game v-model="gameId" />
        <drop-autoComplete label="游戏组" group v-model="gameGroupId" />
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="open">新建策略模板</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { getSysMember } from '@/api/common.model'
import DropAutoComplete from '@/components/dropdown/eldropdown.vue'
import AutoComplete from '@/components/autocomplete/autocomplete'
import { isArray, debounce } from '@/common/js/utils'

export default {
  name: 'policyFilter',
  components: { DropAutoComplete, AutoComplete },
  props: {
    placeholder: {
      type: String
    }
  },
  methods: {
    sendEvent() {
      const params = {
        gameGroupId: this.gameGroupId === -1 ? undefined : this.gameGroupId,
        gameId: this.gameId === -1 ? undefined : this.gameId,
        platform: this.platform === -1 ? undefined : this.platform,
        opId: this.agentId === '' ? undefined : this.agentId,
        keyword: this.keyword === '' ? undefined : this.keyword
      }
      this.$emit('on-change', params)
    },
    search() {
      const params = {
        gameGroupId: this.gameGroupId === -1 ? undefined : this.gameGroupId,
        gameId: this.gameId === -1 ? undefined : this.gameId,
        platform: this.platform === -1 ? undefined : this.platform,
        opId: this.agentId === '' ? undefined : this.agentId,
        keyword: this.keyword === '' ? undefined : this.keyword
      }
      this.$emit('on-search', params)
    },
    proloadData() {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal('list-policy')
      getSysMember()
        .then((data) => {
          if (isArray(data)) {
            this.agentData = data.map((ret) => {
              // ret.id = ret.opId
              return ret
            })
            if (storage && isArray(storage[account])) this.agentId = Number(storage[account])
            else this.agentId = Number(account) || ''
          }
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    handleAgent(meta) {
      this.agentId = meta.id
      if (meta && meta.id) this.setOperatorStorage('list-policy', meta.id)
      else this.setOperatorStorage('list-policy', -1)
    },
    setOperatorStorage(name, value) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    open() {
      this.$router.push({ name: 'policiesadd' })
    }
  },
  watch: {
    gameGroupId(nVal) {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    },
    gameId(nVal) {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    },
    platform(nVal) {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    },
    type(nVal) {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    },
    agentId(nVal) {
      debounce(() => {
        this.sendEvent()
      }, 500)()
    }
  },
  data() {
    return {
      keyword: '',
      gameGroupId: -1, // 游戏组id
      gameId: -1,
      platform: -1,
      agentId: '',
      agentData: []
    }
  },
  created() {
    this.proloadData()
  }
}
</script>
